module.exports = __webpack_public_path__ + "static/media/example.cdd5a807.mp3";